import { RawQueryParams } from "@faire/web/common/query-params/QueryParams";

export const getQuantityMap = (
  params: RawQueryParams
): Map<string, number> | undefined => {
  const quantityString = params.get("quantityMap");
  if (!quantityString) {
    return undefined;
  }
  const quantityMap = new Map<string, number>();
  quantityString.split(",").forEach((pair) => {
    const [key, value] = pair.split(":");
    if (key && value) {
      quantityMap.set(key, parseInt(value, 10));
    }
  });
  return quantityMap;
};
